import $ from 'jquery';

var fileUploadPlaceholder = $('.webform-managed-file-placeholder');

fileUploadPlaceholder.on('click', function(event) {
  var target = $(event.target);
  target.siblings('.form-file').click();
});
